import type { DashboardFilters, DashboardSummary, Paginated } from '@oxxean/types';
import type { FilterOptions, IndicatorRow } from '../../types/domain';
import type { TableState } from '../../hooks/useTableState';
import { http } from '../http';
import { filtersToParams, tableStateToParams } from './params';

export async function fetchFilterOptions(): Promise<FilterOptions> {
  const response = await http.get<FilterOptions>('/catalog/filter-options');
  return response.data;
}

/** Dashboard ejecutivo: 15 KPI y 12 gráficos ya calculados por el backend. */
export async function fetchDashboardSummary(filters: DashboardFilters): Promise<DashboardSummary> {
  const response = await http.get<DashboardSummary>('/dashboard/summary', {
    params: filtersToParams(filters),
  });
  return response.data;
}

/**
 * Resumen de un módulo de indicadores.
 *
 * Comparte forma con el dashboard ejecutivo a propósito: el frontend no calcula
 * nada, sólo presenta `kpis`, `charts` y `provenance` (DEC-A07 y regla de
 * `metrics` como único lugar donde vive una fórmula).
 */
export async function fetchModuleSummary(
  moduleKey: string,
  filters: DashboardFilters,
): Promise<DashboardSummary> {
  const response = await http.get<DashboardSummary>(`/metrics/${moduleKey}/summary`, {
    params: filtersToParams(filters),
  });
  return response.data;
}

export async function fetchModuleRows(
  moduleKey: string,
  filters: DashboardFilters,
  state: TableState,
): Promise<Paginated<IndicatorRow>> {
  const response = await http.get<Paginated<IndicatorRow>>(`/metrics/${moduleKey}/rows`, {
    params: { ...filtersToParams(filters), ...tableStateToParams(state) },
  });
  return response.data;
}
